import { render, staticRenderFns } from "./flag-en.vue?vue&type=template&id=98372c44"
import script from "./flag-en.vue?vue&type=script&lang=js"
export * from "./flag-en.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports